import React from "react";
import PropTypes from 'prop-types';

import Attributes from "./Attributes";
import File from "./File";
import Message from "./Message";
import MessageAsAttribute from "./MessageAsAttribute";
import Owner from "./Owner";
import Workflow from "./Workflow";

const MESSAGE_TYPE  = 'message';
const WORKFLOW_TYPE = 'workflow';
const FILE_TYPE     = 'file';
const OWNER_TYPE    = 'owner';

const Event = ({event, isFirst, attributes = null}) => {
    switch (event.type) {
        case MESSAGE_TYPE:
            if (isFirst) {
                return <MessageAsAttribute body={event.body}/>;
            }

            return <Message body={event.body}/>;
        case WORKFLOW_TYPE:
            if (isFirst) {
                return <Attributes event={event} attributes={attributes}/>;
            } else {
                return <Workflow workflowStatus={event.workflowStatus}/>;
            }
        case FILE_TYPE:
            return <File threadFile={event.threadFile}/>;
        case OWNER_TYPE:
            return <Owner owner={event.owner}/>;
        default:
            throw new Error("Unknow event type: " + event.type);
    }
};

Event.propTypes = {
    event: PropTypes.any.isRequired,
    isFirst: PropTypes.bool.isRequired,
    attributes: PropTypes.any
};

export default Event;
